import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function ExecutiveSerifTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl p-8 shadow-2xl text-[13px] leading-snug font-serif" data-testid="resume-live-preview">
      <div className="text-center border-b-2 pb-4" style={{ borderColor: accent }}>
        <h1 className="text-3xl font-bold tracking-wide" style={{ color: accent }}>{draft.full_name || "Your Name"}</h1>
        {draft.target_role && <p className="text-slate-600 text-sm mt-1 italic">{draft.target_role}</p>}
        <p className="text-slate-500 text-xs mt-1.5">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join("  ·  ")}</p>
      </div>

      {draft.summary && (
        <div className="mt-5 text-center">
          <p className="text-slate-700 italic">{draft.summary}</p>
        </div>
      )}
      {draft.experience.length > 0 && (
        <div className="mt-5">
          <h2 className="text-xs font-bold uppercase tracking-[0.2em] text-center border-b pb-1.5 mb-3" style={{ color: accent, borderColor: `${accent}40` }}>Professional Experience</h2>
          {draft.experience.map((e, i) => (
            <div key={i} className="mt-2.5">
              <div className="flex justify-between items-baseline">
                <p className="font-bold text-slate-800">{e.title}, {e.company}</p>
                <span className="text-slate-400 italic text-xs">{dateRange(e.start_date, e.end_date, e.current)}</span>
              </div>
              <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
            </div>
          ))}
        </div>
      )}
      {draft.education.length > 0 && (
        <div className="mt-5">
          <h2 className="text-xs font-bold uppercase tracking-[0.2em] text-center border-b pb-1.5 mb-3" style={{ color: accent, borderColor: `${accent}40` }}>Education</h2>
          {draft.education.map((ed, i) => (
            <p key={i} className="text-slate-700 mt-1 text-center"><span className="font-semibold text-slate-800">{ed.degree} {ed.field}</span> — {ed.school} <span className="text-slate-400 italic">({ed.start_date} - {ed.end_date})</span></p>
          ))}
        </div>
      )}
      {draft.skills.length > 0 && (
        <div className="mt-5">
          <h2 className="text-xs font-bold uppercase tracking-[0.2em] text-center border-b pb-1.5 mb-3" style={{ color: accent, borderColor: `${accent}40` }}>Core Competencies</h2>
          <p className="text-slate-700 mt-1 text-center">{draft.skills.join("  ·  ")}</p>
        </div>
      )}
      <ExtraResumeSections draft={draft} accent={accent} />
    </div>
  );
}
